import { Injectable } from '@angular/core';
import { Routes, Route } from '@angular/router';
import { RoleGuardService } from 'src/app/core/guard/role-guard.service';
import { DefaultLayoutComponent } from '../../layout/default-layout/default-layout.component';
import { LoginLayoutComponent } from '../../layout/login-layout/login-layout.component';

@Injectable({
  providedIn: 'root'
})

export class ShellService {

  constructor() { }

  static childRoutes(routes: Routes): Route {
    return {
      path: '',
      component: DefaultLayoutComponent,
      children: routes,
      canActivate: [RoleGuardService],
      data: { reuse: true }
    };
  }

  static childRoutesPublic(routes: Routes): Route {
    return {
      path: '',
      component: DefaultLayoutComponent,
      children: routes,
      canActivate: [],
      data: { reuse: true }
    };
  }
}
